import { render, staticRenderFns } from "./FilialsSelectField.vue?vue&type=template&id=61ad95c4&scoped=true&"
import script from "./FilialsSelectField.vue?vue&type=script&lang=js&"
export * from "./FilialsSelectField.vue?vue&type=script&lang=js&"
import style0 from "./FilialsSelectField.vue?vue&type=style&index=0&id=61ad95c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad95c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
